import { TranslationSegment } from './TranslationSegment';

export function getMergeKey(segment: TranslationSegment): string {
    return segment.groupId ?? segment.paragraphId;
}
